<mat-card class="xp-dialog__card"
          role="dialog"
          [attr.aria-labelledby]="header()?.headingId"
          [attr.aria-label]="ariaLabel() || null">
	<ng-content></ng-content>
</mat-card>
